import Vue from 'vue'
import Router from 'vue-router'
import Error from '@/components/Error'
import ErrorContent from '@/components/ErrorContent'
import Faq from '@/components/Faq'
import Consent from '@/components/Consent'
import ConsentPath from '@/components/ConsentPath'
import OptOut from '@/components/OptOut'
import EnterCode from '@/components/EnterCode'
import NextStep from '@/components/NextStep'
import Login from '@/components/Login'
import Auth from '@/components/Auth'
import Survey from '@/components/Survey'
import SessionExpired from '@/components/SessionExpired'
import EndParticipation from '@/components/EndParticipation'
import { handleSessionIdQueryParam } from '../plugins/queryparam'

// Silences NavigationDuplicated error
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'auth',
      component: Auth,
      meta: {}
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*', // all other paths,
      name: 'error', // goes to this,
      component: Error, // since most components are routed,
      meta: {} // and neccessary for the application.
    },
    {
      path: '/errorcontent',
      name: 'errorcontent',
      component: ErrorContent,
      meta: {}
    },
    {
      path: '/faq/:page',
      name: 'faq',
      component: Faq,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/nextstep',
      name: 'nextstep',
      component: NextStep,
      meta: {
        requiresJWT: true
      }
    },
    {
      path: '/consent',
      name: 'consent',
      component: Consent,
      meta: {
        requiresSessionId: true
      }
    },
    {
      path: '/consentpath',
      name: 'consentpath',
      component: ConsentPath,
      meta: {
        requiresJWT: true
      }
    },
    {
      path: '/entercode',
      name: 'entercode',
      component: EnterCode,
      meta: {
        requiresJWT: true
      }
    },
    {
      path: '/survey',
      name: 'survey',
      component: Survey,
      props: true,
      meta: {
        requiresJWT: true
      }
    },
    {
      path: '/optout',
      name: 'optout',
      component: OptOut,
      meta: {
        requiresJWT: false
      }
    },
    {
      path: '/sessionexp',
      name: 'sessionexp',
      component: SessionExpired,
      meta: {}
    },
    {
      path: '/endpart',
      name: 'endparticipation',
      component: EndParticipation,
      meta: {
        requiresJWT: true
      }
    }
  ],
  scrollBehavior () {
    setTimeout(() => { window.scrollTo(0, 0) })
  }
})

/* Route Guard */
router.beforeEach((to, from, next) => {
  handleSessionIdQueryParam()

  if (to.matched.some(route => route.meta.requiresSessionId)) {
    if (sessionStorage.getItem('sessionId')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  if (to.matched.some(route => route.meta.requiresJWT)) {
    if (sessionStorage.getItem('jwt')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (localStorage.getItem('access')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js